import { render, staticRenderFns } from "./Atendente.vue?vue&type=template&id=1a526588&"
import script from "./Atendente.vue?vue&type=script&lang=js&"
export * from "./Atendente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports